/**
 * Dev-gated console wrapper.
 *
 * Diagnostic logging (WebRTC/WS state, STT lifecycle, viseme debug, etc.) is
 * useful while developing but must not reach the browser console in production
 * builds, where it can expose internal state / user information to anyone who
 * opens devtools (CWE-532). In a production build every method below is a no-op.
 *
 * This is intentionally NOT a place to log secrets even in dev — callers must
 * still avoid passing tokens, passwords or raw request/response objects.
 */
const isDev = process.env.NODE_ENV !== 'production';

type LogArgs = unknown[];

export const logger = {
    log: (...args: LogArgs): void => {
        if (isDev) console.log(...args);
    },
    warn: (...args: LogArgs): void => {
        if (isDev) console.warn(...args);
    },
    error: (...args: LogArgs): void => {
        if (isDev) console.error(...args);
    },
};
